export default class FilterYears {
    static init() {
        const listings = document.querySelectorAll(".listing-container");

        listings.forEach(listing => {
            this.initFilter(listing);
        });
    }

    static initFilter(listing) {
        const filter = listing.querySelector(".filter-years");
        const cards = listing.querySelectorAll(".filterable");

        filter.addEventListener("change", () => {
            const currentYear = filter.value;

            cards.forEach(card => {
                if (card.dataset.year === currentYear || currentYear === "all") {
                    card.classList.remove("hidden");
                } else {
                    card.classList.add("hidden");
                }
            });
        });
    }
}
